module.exports = __webpack_public_path__ + "static/media/iStock-1250688024.2eaafb67.gif";